import { cva, type VariantProps } from 'class-variance-authority'
import * as React from 'react'

import { cn } from '#app/utils/misc.tsx'

const errorMessageVariants = cva(
	'text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 pb-[2px] text-status-danger flex flex-col gap-xxxs',
)

const ErrorMessages = React.forwardRef<
	HTMLDivElement,
	React.ComponentPropsWithoutRef<'div'> &
		VariantProps<typeof errorMessageVariants> & {
			errors?: string[]
		}
>(({ className, children, ...props }, ref) => {
	if (!props.errors || props.errors.length === 0) return null

	return (
		<div ref={ref} className={cn(errorMessageVariants(), className)} {...props}>
			{props.errors.map((error, index) => (
				<p key={index}>{error}</p>
			))}
		</div>
	)
})
ErrorMessages.displayName = 'ErrorMessages'

export { ErrorMessages }
